<template>
    <div class="container-contact">
        <div class="back-contact" v-on:click="goBack">
            <div class="">Retourner sur le site</div>
        </div>
        <div class="content-contact">
            <h1 class="title-contact">Formulaire de Contact</h1>
        <div style="display:contents">
            <input type="text" class="form-control" id="name" placeholder="Nom"/>
            <input type="text" class="form-control" id="surname" placeholder="Prénom"/>
            <input type="text" class="form-control" id="tel" placeholder="Téléphone (OPTIONNEL)"/>
            <input type="mail" class="form-control" id="mail" placeholder="Adresse mail"/>
            <textarea style="height:11rem" class="form-control" id ="request" placeholder="Contenu de votre requête"/>
                <div class="button-1" id="submit" v-on:click="sendMail">Envoyer</div>
        </div>
        </div>
    </div>
</template>


<script>
export default {
    name : 'Contact',
    beforeCreate: function() {
        document.body.className = 'contact';
    },
    methods : {
        goBack : function()
        {
            this.$router.go(-1);
        },
        sendMail : function()
        {
            const submit = document.getElementById('submit');
            submit.disabled =true;
            const name =document.getElementById('name').value;
            const surname =document.getElementById('surname').value;
            const tel =document.getElementById('tel').value;
            const mail =document.getElementById('mail').value;
            const request =document.getElementById('request').value;
            var sendMail = this.$functions.httpsCallable('sendMail');
            sendMail({name: name, surname: surname, tel : tel,mail : mail, request: request  }).then(function(result) {
            // Read result of the Cloud Function.
            var reponse = result.data;
            console.log(reponse)
            // ...
            });
        }
    }
    
}
</script>


<style scoped>
.button-1{
    background-color: #03A9F4;
    cursor: pointer;
    border-color: none;
    color: white;
    border-radius: 0.10rem;
    border-width:0px ;
    padding: 0.8rem;
    flex-shrink: 0;
    margin-left: 0.2rem;
    transition-duration: 0.2s;
}

.back-contact {
    position: absolute;
    bottom: 0;
    left: 0;
    margin: 1rem;
    cursor: pointer;
    display: flex;
    overflow: hidden;
    transition-duration: 0.2s;
}




.back-contact div:hover {
    color: black!important;
}



.back-contact div {
    margin: auto;
    font-family: 'Montserrat', sans-serif;
    font-weight: 800;
    font-size: 2rem;
    filter: drop-shadow(0 0 0.08rem black);
    color: white;
    transition-duration:0.2s;
}



.back-contact img {
    filter: drop-shadow(0 0 0.08rem black);
}

.button-1:hover{
     background-color: steelblue;
}

.container-contact {
    margin: 1rem;
    min-height: 100vh;
}

.content-contact {
   
    display: flex;
    box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.57);
    flex-direction: column;
    padding: 1.5rem;
    
    margin: auto;
    width: 50%;
    background-color: white;
}

@media (max-width: 43rem)
{
    .content-contact {
        width: 100%!important;
        
    }
}
.title-contact {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 3rem;
    
    letter-spacing: -0.2rem;
}

.form-control {
    margin: 0.25rem!important;
}

</style>